export default __webpack_public_path__ + "static/media/orderit-logo.df239e66.png";